import axios from "axios";
import i18n from "locales/i18n";
// import { useDispatch } from "react-redux";
// import { LOGOUT } from "store/reducers/auth";
import { getAccessTokenFromRedux, getRefreshTokenFromRedux } from './authService';
import { dispatch, store } from "../../store";
import { LOGIN } from "store/reducers/auth";
import { forceLogout } from "./forceLogout";
import { updateLastActivity } from "./activityTracker";
// import { useLocation } from "react-router-dom";

// ✅ 공통 인터셉터 함수
let isRefreshing = false;
let failedQueue = [];

function applyLanguageInterceptor(instance) {
  instance.interceptors.request.use(config => {
    config.headers['Accept-Language'] = i18n.language;
    return config;
  });
}

const refreshAxios = axios.create({
  baseURL: window.RUNTIME_CONFIG.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});
applyLanguageInterceptor(refreshAxios);

function processQueue(error, token = null) {
  failedQueue.forEach(promise => {
    if (error) {
      promise.reject(error);
    } else {
      promise.resolve(token);
    }
  });
  failedQueue = [];
}

function applyInterceptors(instance) {
  instance.interceptors.request.use(
    config => {
      // ✅ API 요청 = 사용자 활동
      updateLastActivity();
      
      // const token = getAccessToken();
      const token = getAccessTokenFromRedux();
      // console.log(token)
      if (token) {
                // let payload = token.substring(token.indexOf('.')+1,token.lastIndexOf('.'));
                // //  console.log(payload)
                // //  let decodingInfo = base64.decode(payload);
                // //  console.log("authtoken decode ", decodingInfo)
                // //  let decodingInfoJson = JSON.parse(decodingInfo);
                // const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // const jsonPayload = decodeURIComponent(
                //   atob(base64)
                //     .split('')
                //     .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                //     .join('')
                // );
                // let decodingInfoJson = JSON.parse(jsonPayload);
                // console.log("AccessTokenByExpired expiredTime : ", (decodingInfoJson.exp - (Date.now() / 1000))/60)
                // console.log("AccessTokenByExpired expiredTime(sec) : ", (decodingInfoJson.exp - (Date.now() / 1000))/60/60)
        // // console.log("AccessTokenByExpired expiredTime : ", (decodingInfoJson.exp - (Date.now() / 1000))/60)
        config.headers.Authorization = `Bearer ${token}`;
      }
      config.headers['Accept-Language'] = i18n.language;
      return config;
    },
    error => Promise.reject(error)
  );

  instance.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = error.config;

      // 네트워크 오류 등
      if (!error.response || !originalRequest) {
        return Promise.reject(error);
      }

      // refresh API 자체는 interceptor 대상 제외
      if (originalRequest.url?.includes('/api/public/login/refresh')) {
        return Promise.reject(error);
      }
// console.log(error.response);
// console.log(originalRequest);
      if ((error.response?.status === 401 || error.response?.status === 403) && !originalRequest._retry) {
        originalRequest._retry = true;

        // console.log(error.response.data.code);
        // console.log(error.response.data.message);
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          }).then(token => {
            // console.log(token)
            originalRequest.headers.Authorization = `Bearer ${token}`;
            originalRequest.headers['Accept-Language'] = i18n.language;
            return instance(originalRequest);
          });
        }

        isRefreshing = true;
        try {
          // const refreshToken = getRefreshToken();
          const refreshToken = getRefreshTokenFromRedux();
          if (!refreshToken) {
            // isRefreshing = false;
            processQueue(new Error('No refresh token'), null);
            // window.location.href = '/auth/logoutProcess';
            await forceLogout(store.dispatch, window.__APP_NAVIGATE__);
            return Promise.reject(error);
          }

          // let payload = refreshToken.substring(refreshToken.indexOf('.')+1,refreshToken.lastIndexOf('.'));
          // const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
          // const jsonPayload = decodeURIComponent(
          //   atob(base64)
          //     .split('')
          //     .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          //     .join('')
          // );
          // let decodingInfoJson = JSON.parse(jsonPayload);
          // console.log("RefreshTokenByExpired expiredTime : ", (decodingInfoJson.exp - (Date.now() / 1000))/60)
          // console.log("RefreshTokenByExpired expiredTime(sec) : ", (decodingInfoJson.exp - (Date.now() / 1000))/60/60)

          const { data } = await refreshAxios.post('/api/public/login/refresh', { refresh_token:refreshToken });
          // console.log(data)
          if (!data?.id_token) {
            throw new Error('Invalid refresh response');
          }
          // if (data.id_token) {
            dispatch(LOGIN({accessToken:data.id_token, refreshToken:data.refresh_token}));
            // dispatch(LOGIN(data));//{accessToken:res.data.id_token}
            processQueue(null, data.id_token);

            originalRequest.headers.Authorization = `Bearer ${data.id_token}`;
            originalRequest.headers['Accept-Language'] = i18n.language;
            return instance(originalRequest);
          // } else {
          //   processQueue(data.error_message, null);
          //   console.log(data.error_message)
          //   window.location.href = '/auth/logoutProcess';
          //   return Promise.reject(data.error_message);
          // }
        } catch (refreshError) {
          // processQueue(refreshError, null);
          // // console.log(refreshError)
          // window.location.href = '/auth/logoutProcess';
          processQueue(refreshError, null);
          // setTimeout(() => {
          //   window.location.href = '/auth/logoutProcess';
          // }, 0);
          await forceLogout(store.dispatch, window.__APP_NAVIGATE__);
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }

      return Promise.reject(error);
    }
  );
}

// ✅ 공통 axios 인스턴스
const axiosInstance = axios.create({
  baseURL: window.RUNTIME_CONFIG.REACT_APP_API_URL,
});
applyInterceptors(axiosInstance);

// ✅ 개별 인스턴스 생성 함수
function createCustomAxios(options = {}) {
  const instance = axios.create({
    baseURL: window.RUNTIME_CONFIG.REACT_APP_API_URL,
    ...options,
  });
  applyInterceptors(instance);
  return instance;
}


// ✅ 다양한 요청용 인스턴스 정의
export const customAxios = createCustomAxios({
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
    Accept: 'application/json',
  },
  // 모든 Axios 요청에서 배열을 쿼리스트링으로 바꿀 때 대괄호([])를 빼고 깨끗하게 이름만 반복하도록 설정합니다.
  paramsSerializer: {
    indexes: null // 대괄호 제거 속성
  }
});

export const customPatchAxios = createCustomAxios({
  headers: {
    'Content-Type': 'application/merge-patch+json; charset=UTF-8',
    Accept: 'application/json',
  },
  // 모든 Axios 요청에서 배열을 쿼리스트링으로 바꿀 때 대괄호([])를 빼고 깨끗하게 이름만 반복하도록 설정합니다.
  paramsSerializer: {
    indexes: null // 대괄호 제거 속성
  }
});

export const customFileAxios = createCustomAxios({
  headers: {
    'Content-Type': 'multipart/form-data',
    Accept: 'application/json',
  },
  // 모든 Axios 요청에서 배열을 쿼리스트링으로 바꿀 때 대괄호([])를 빼고 깨끗하게 이름만 반복하도록 설정합니다.
  paramsSerializer: {
    indexes: null // 대괄호 제거 속성
  }
});

export const customFileDownAxios = createCustomAxios({
  responseType: 'blob',
});

// ✅ 로그인 전 요청 (토큰 필요 없음)
export const customLoginAxios = axios.create({
  baseURL: window.RUNTIME_CONFIG.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
    Accept: 'application/json',
  },
});
applyLanguageInterceptor(customLoginAxios);

export const customLoginFileAxios = axios.create({
  baseURL: window.RUNTIME_CONFIG.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
    Accept: 'application/json',
  },
});
applyLanguageInterceptor(customLoginFileAxios);

export default axiosInstance;